module.exports = __webpack_public_path__ + "media/images/front/doctor-noimage-28aeaf67f5666b478b91d33a303fbe9c.png";